/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateSubjectStatus.defs.js'
export { main as default } from './updateSubjectStatus.defs.js'
